
import './App.css';
import {Contact, Home} from './Pages'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/contact" element={<Contact />} />
          {/*  <Route path="contact" element={<h1>helo contact</h1>} />*/}
          {/*  <Route path="*" element={<h1>helo 0</h1>} />*/}
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
